import { AddCommar, ConvertDateToText, ConvertTimeToText, TextDate } from 'components/MyControl';
import Css from './Customer.module.css';
import { Row, Col, Form, Button, Tab, Table, InputGroup, Modal } from "react-bootstrap";
import { useEffect, useState } from 'react';
import ApiConection from "api_ref/ApiConection";
import moment from 'moment';

export default function ServicePayment({ stepPage = 1,dataSubmit = undefined, data = undefined, disabled = false,onChangeData=undefined }) {
    const api = new ApiConection();

    const [show, setShow] = useState(false);
    const [hour, setHour] = useState([]);
    const [minute, setMinute] = useState([]);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [preview, setPreview] = useState(undefined);
    const [fileType, setFileType] = useState(undefined);
    const [paymentStatus, setPaymentStatus] = useState([]);

    const [slipPic, setSlipPic] = useState(undefined);
    const [widthHoldingTaxPic, setWidthHoldingTaxPic] = useState(undefined);

    const [paidInfo, setPaidInfo] = useState({
        paid_date: '',
        paid_hour: '00',
        paid_minute: '00',
    })

    const GetHour = () => {
        let data = [];
        for (let i = 0; i <= 23; i++) {
            let text = '00' + i;
            text = text.substr(text.length - 2, 2);
            data.push(text);
        }
        setHour(data);
    }

    const GetMinute = () => {
        let data = [];
        for (let i = 0; i < 60; i++) {
            let text = '00' + i;
            text = text.substr(text.length - 2, 2);
            data.push(text);
        }
        setMinute(data);
    }

    const handlePaidInfoChange = (event) => {
        const { name, value, type, files } = event.target;

        setPaidInfo(prevData => {
            return { ...prevData, [name]: (files ? files[0] : undefined || value) }
        });
    }
    const getPaidInfo = (name) => {
        return paidInfo[name];
    }

    const getPaymentStatus = async ()=>{
        if (data !== undefined) {
            const response = await api.getData(`api/master/payment-status`);
            //console.log(response)
            if(response?.status === false)
                setPaymentStatus([]);
            else{
                // package free
                console.log(data)
                if(data?.package_master_id === 1){
                    setPaymentStatus(response?.data.filter( x => x.id === 99));
                }else{
                    setPaymentStatus(response?.data.filter( x => x.id !== 99));
                }
                
            }
        } else {
            setPaymentStatus([]);
        }
    }

    const getSlipFile = async (id) => {
        if (id !== null && id !== undefined) {
            return await api.getFile(`api/file/${id}/preview`);
        } else {
            return undefined;
        }
    }

    const getPicture = async () => {
        const response_slip = await getSlipFile(data.slip_file_id);
        //console.log(response_slip);
        if (response_slip === undefined)
            setSlipPic(undefined);
        else
            setSlipPic({
                image: URL.createObjectURL(response_slip),
                data: response_slip
            });

        const response_holding = await getSlipFile(data.with_holding_text_certficate_id);
        if (response_holding === undefined)
            setWidthHoldingTaxPic(undefined);
        else
            setWidthHoldingTaxPic({
                image: URL.createObjectURL(response_holding),
                data: response_holding
            });
    }

    const showPic = async (file_id) => {
        if (file_id === 1) {
            if (slipPic === undefined) return;

            if (slipPic !== undefined && slipPic?.data?.type?.indexOf) {
                setFileType(slipPic?.data?.type);
                setPreview(slipPic?.image);
                setShow(true);
            }
        } else {
            if (widthHoldingTaxPic === undefined) return;

            if (widthHoldingTaxPic !== undefined && widthHoldingTaxPic?.data?.type?.indexOf) {
                setFileType(widthHoldingTaxPic?.data?.type);
                setPreview(widthHoldingTaxPic?.image);
                setShow(true);
            }
        }

        //console.log(response?.type);
    };

    useEffect(() => {
        const fetchData = async () => {

            GetHour();
            GetMinute();

            if(data?.paid_date !== null){
                let paid_date = moment(data.paid_date, 'YYYY-MM-DDTHH:mm:ss');

                setPaidInfo({
                    paid_date: paid_date.format('DD/MM/YYYY'),
                    paid_hour: paid_date.format('HH'),
                    paid_minute: paid_date.format('mm'),
                })
            }
            await getPaymentStatus();
            await getPicture();
        }

        fetchData();
    }, [])

    useEffect(()=>{
        let paid_date = moment(paidInfo.paid_date + ' ' + paidInfo.paid_hour + ":" + paidInfo.paid_minute, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DDTHH:mm:ss');
        
        if(paid_date !== 'Invalid date'){
            onChangeData({target:{name:'paid_date',value:paid_date}});
        }
    },[paidInfo])

    return (
        <div className={Css.Register_customer_layout5}>

            <label className={Css.colorfont}><h6>หลักฐานการชำระค่าบริการ</h6></label><br />
            <Row className={Css.body2 + ' mt-2'}>
                <Col>
                    <Form.Label>สถานะชำระของลูกค้า</Form.Label><br/>
                    {
                        disabled === true &&
                        <Form.Label className={Css.colorfont}>{data?.payment_status_name}</Form.Label>
                    }
                    {
                        disabled === false &&
                        <Form.Select name={`payment_status_id`} value={(dataSubmit?.payment_status_id ?? data?.payment_status_id)} onChange={event => onChangeData(event)}>
                            {
                                paymentStatus?.map((obj,index)=>(
                                    <option key={index} value={obj.id}>{obj.name}</option>
                                ))
                            }
                        </Form.Select>
                    }
                    
                    
                </Col>
            </Row>
            <Row className={Css.body2 + ' mt-3'}>
                
                <Col>
                    <Form.Label>ใบเสร็จชำระค่าบริการ</Form.Label>
                    <div className="text-center mb-3" style={{ cursor: 'pointer' }} onClick={event => showPic(1)} >
                        {
                            slipPic !== undefined && slipPic?.data?.type.indexOf('image') > -1 &&
                            <img src={(slipPic?.image)} width={124} />
                        }
                        {
                            slipPic !== undefined && slipPic?.data?.type.indexOf('image') === -1 &&
                            <>
                                <img src={require('images/document-901.png')} style={{ marginTop: '0', width: 'auto', height: '80%' }} width={124} />
                                <br />
                                <span>{slipPic?.data?.name}</span>
                            </>
                        }
                    </div>
                    <Form.Label>เอกสารหัก ณ ที่จ่าย</Form.Label>
                    <div className="text-center" style={{ cursor: 'pointer' }} onClick={event => showPic(2)} >
                        {
                            widthHoldingTaxPic !== undefined && widthHoldingTaxPic?.data?.type.indexOf('image') > -1 &&
                            <img src={(widthHoldingTaxPic?.image)} width={124} />
                        }
                        {
                            widthHoldingTaxPic !== undefined && widthHoldingTaxPic?.data?.type.indexOf('image') === -1 &&
                            <>
                                <img src={require('images/document-901.png')} style={{ marginTop: '0', width: 'auto', height: '80%' }} width={124} />
                                <br />
                                <span>{widthHoldingTaxPic.data?.name}</span>
                            </>
                        }

                    </div>
                </Col>

                <Col>
                    <Row className='mb-2'>
                        <Form.Label>ธนาคาร</Form.Label>
                        <Form.Label className={Css.colorfont}>{data?.paid_bank}</Form.Label>
                    </Row>
                    <Row className='mb-2'>
                        <Form.Label>จำนวนเงินที่ชำระ</Form.Label>
                        <Form.Label className={Css.colorfont}>{AddCommar(data?.paid_amount)} บาท</Form.Label>
                    </Row>
                    <Row className='mb-2 '>
                        <Form.Label >วันที่ชำระ</Form.Label>
                        {
                            disabled === true &&
                            <Form.Label className={Css.colorfont}>{ConvertDateToText(data?.paid_date)}</Form.Label>
                        }
                        {
                            disabled === false &&
                            <TextDate name={'paid_date'} value={getPaidInfo('paid_date')} onChange={event => handlePaidInfoChange(event)} required={true} />
                            
                        }

                    </Row>
                    <Row className='mb-2' >
                        <Form.Label >เวลาที่ชำระ</Form.Label>
                        {
                            disabled === true &&
                            <Col>
                                <Form.Label className={Css.colorfont}>{ConvertTimeToText(data?.paid_date)} น.</Form.Label>
                            </Col>
                        }
                        {
                            disabled === false &&
                            <Col className='text-start'>
                                <InputGroup>
                                    <Form.Select name={'paid_hour'} className='border-end-0' value={getPaidInfo('paid_hour')} onChange={event => handlePaidInfoChange(event)} required={true}>
                                        {
                                            hour.map((obj, index) => {
                                                return (
                                                    <option key={index} value={obj}>{obj}</option>
                                                )
                                            })
                                        }
                                    </Form.Select>
                                    <InputGroup.Text className='bg-white p-2'>:</InputGroup.Text>
                                    <Form.Select name={'paid_minute'} className='border-start-0 border-end-0' value={getPaidInfo('paid_minute')} onChange={event => handlePaidInfoChange(event)} required={true}>
                                        {
                                            minute.map((obj, index) => {
                                                return (
                                                    <option key={index} value={obj}>{obj}</option>
                                                )
                                            })
                                        }
                                    </Form.Select>
                                    <InputGroup.Text className='bg-white'><i className="fa-regular fa-clock"></i></InputGroup.Text>
                                </InputGroup>

                            </Col>
                        }
                    </Row>
                </Col>
            </Row>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {
                        preview === undefined &&
                        <span>ไม่สามารถแสดงไฟล์ได้</span>
                    }
                    {
                        preview !== undefined &&
                        fileType.indexOf('image') > -1 &&
                        <img alt='' src={preview} style={{ marginTop: '0', width: '100%', height: 'auto' }} />
                    }
                    {
                        preview !== undefined &&
                        fileType.indexOf('image') === -1 &&
                        <embed alt='' src={preview} style={{ marginTop: '0', width: '100%', height: '500px' }} />
                    }
                </Modal.Body>
            </Modal>
        </div>
    )
}